<script lang="ts">
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'SuggestTags',

  props: {
    items: {
      type: Array as PropType<SuggestWordItem[]>,
      required: true,
    },
  },
})
</script>

<template>
  <div class="o-list__suggestWord">
    <ul class="o-list__suggestWord--items">
      <li
        v-for="(item, index) in items"
        :key="item.id || index"
        class="o-list__suggestWord--item">
        <div class="o-action__suggestWord">
          <a
            v-if="!!item.to"
            class="o-action__suggestWord--item"
            :href="item.to">
            # {{ item.label }}
          </a>
          <p
            v-else
            class="o-action__suggestWord--item">
            # {{ item.label }}
          </p>
        <!-- /.o-action__suggestWord --></div>
      </li>
    </ul>
  <!-- /.o-list__suggestWord --></div>
</template>

<style lang="sass" scoped>
// object
.o-list__suggestWord
  $gap: 0.5em
  & &--items
    display: flex
    flex-wrap: wrap
    margin:
      top: -($gap)
      left: -($gap)

  & &--item
    margin:
      top: $gap
      left: $gap

.o-action__suggestWord
  $root: &

  & &--item
    display: block
    line-height: 1
    color: $bg-xx-dark-gray
    font-size: $font-small
    text-decoration: none
    padding: changeSizePx2Em(8, $font-small-px) changeSizePx2Em(16, $font-small-px)
    background-color: rgba($bg-white, 1)
    border: 1px solid $border-x-light-gray
    border-radius: 100vh
    +transition

    &[href]
      +mouseover
        color: $font-dark-orange
        border-color: $border-dark-orange
        box-shadow: $button-shadow

  +breakpoint
    #{$root}--item
      font-size: $font-small
</style>
